module.exports = __webpack_public_path__ + "img/union.07540f35.svg";